import { useAtomValue } from 'jotai';
import { useNavigate } from 'react-router';

import { TagSelection } from '@screens';
import { activeUserIdAtom, activityIdAtom } from '@store';

import { LINKS } from '../utils/routes';

export const TagSelectionScreen = () => {
    const activityId = useAtomValue(activityIdAtom);
    const activeUserId = useAtomValue(activeUserIdAtom);
    const navigate = useNavigate();
    return (
        <TagSelection
            activityId={activityId}
            activeUserId={activeUserId}
            onClose={() => navigate(LINKS.getFullActivity())}
        />
    );
};
